'use client';

import { useActionState } from 'react';
import { signup } from '../actions/auth';
import { redirect } from 'next/navigation';
import Link from 'next/link';

export default function RegisterPage() {
    const [signupState, signupAction, signupPending] = useActionState(async (prev: any, formData: FormData) => {
        const res = await signup(prev, formData);
        if (res.success) {
            redirect('/dashboard');
        }
        return res;
    }, null);

    return (
        <div className="min-h-screen flex items-center justify-center bg-slate-950 bg-[url('https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=80&w=2672&auto=format&fit=crop')] bg-cover bg-center bg-no-repeat relative">
            {/* Overlay */}
            <div className="absolute inset-0 bg-slate-900/80 backdrop-blur-sm"></div>

            <div className="relative w-full max-w-md p-8 bg-slate-900/60 border border-slate-700/50 backdrop-blur-xl rounded-2xl shadow-2xl">
                <div className="text-center mb-8">
                    <h1 className="text-4xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500 tracking-tight mb-2">
                        Oscops.Net
                    </h1>
                    <p className="text-slate-400 text-sm">Create Your Account</p>
                </div>

                <form action={signupAction} className="space-y-4" autoComplete="off">
                    <div>
                        <label className="block text-xs font-bold text-slate-400 mb-1 uppercase tracking-wide">Email</label>
                        <input id="signup-email" name="email" type="email" autoComplete="off" required className="w-full bg-slate-800 border border-slate-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 transition" placeholder="user@example.com" />
                    </div>
                    <div>
                        <label className="block text-xs font-bold text-slate-400 mb-1 uppercase tracking-wide">Password</label>
                        <input id="signup-password" name="password" type="password" autoComplete="new-password" required className="w-full bg-slate-800 border border-slate-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 transition" placeholder="Create a strong password" />
                    </div>
                    <div>
                        <label className="block text-xs font-bold text-slate-400 mb-1 uppercase tracking-wide">Phone</label>
                        <input id="signup-phone" name="phone" type="tel" autoComplete="tel" className="w-full bg-slate-800 border border-slate-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 transition" placeholder="+1234..." />
                    </div>

                    {signupState?.message && <p className="text-red-400 text-sm text-center bg-red-500/10 py-2 rounded">{signupState.message}</p>}

                    <button disabled={signupPending} className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-500 hover:to-indigo-500 text-white font-bold py-3 rounded-xl shadow-lg shadow-blue-500/20 transition-all disabled:opacity-50 disabled:cursor-wait">
                        {signupPending ? 'Creating Account...' : 'Get Started'}
                    </button>
                </form>

                <div className="mt-6 text-center">
                    <p className="text-slate-400 text-sm">
                        Already have an account?{' '}
                        <Link href="/" className="text-cyan-400 hover:text-cyan-300 font-semibold transition-colors">
                            Login
                        </Link>
                    </p>
                </div>

                <div className="mt-8 text-center">
                    <p className="text-xs text-slate-500">oscops.net</p>
                </div>

            </div>
        </div>
    );
}
